<template>
  <div class="mt-4">
    <base-input placeholder="Search...." v-model="searchTerm" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchTerm: ""
    };
  }
};
</script>
